import { useEffect } from 'react';

import type { AlineEditor, PlaywrightAdapter } from '@aline/common';
import {
  AlineTransforms,
  getPresenceColor,
  isCheckboxElement,
  isCheckboxOptionFieldElement,
  isInputFieldElement,
  isParagraphElement,
  isRenderModelLine,
  isRenderModelPage,
  Queries,
  SelEventSource,
} from '@aline/common';
import { Editor, Node, Text, Transforms } from 'slate';
import { IS_PLAYWRIGHT } from 'src/helpers/environment';

declare global {
  interface Window {
    playwrightAdapter?: PlaywrightAdapter;
  }
}

export const usePlaywrightIfEnabled = IS_PLAYWRIGHT ? usePlaywright : () => {};

function usePlaywright(editor: AlineEditor) {
  useEffect(() => {
    window.playwrightAdapter = {
      AlineTransforms,
      Editor,
      Node,
      Queries,
      SelEventSource,
      Text,
      Transforms,
      editor,
      getPresenceColor,
      isCheckboxElement,
      isCheckboxOptionFieldElement,
      isInputFieldElement,
      isParagraphElement,
      isRenderModelLine,
      isRenderModelPage,
    };
  }, [editor]);
}
